import * as yup from 'yup'

const schema = yup.object().shape({
  email: yup.string().email('Email inválido').trim(),

  emailList: yup
    .array()
    .min(1, 'É obrigatório adicionar pelo menos um email à lista')
    .of(yup.string().email('Email inválido').required('Email é obrigatório')),
})

export default schema
